import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from '../../utils/auth'
import {loadWalkInInterestsByRefsReducer} from './modules/WalkInInterestsPrint'
import {walkInInterestFormReducer} from '../WalkInInterests/modules/walkInInterests'

export default (store) => ({
  path: 'walk-in-interests-print/:walkInInterestRefs',
  onEnter: isLoggedIn(store),
  isPrintView: true,
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      const WalkInInterestsPrint = require('./containers/WalkInInterestsPrint').default
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'walkInInterestsByRefs', reducer: loadWalkInInterestsByRefsReducer})
      injectReducer(store, {key: 'walkInInterestForm', reducer: walkInInterestFormReducer})

      /*  Return getComponent   */
      cb(null, WalkInInterestsPrint)

      /* Webpack named bundle   */
    }, 'walkInInterestsPrint')
  }
})



// WEBPACK FOOTER //
// ./src/routes/WalkInInterestsPrint/index.js